export function mountStatisticCounters(root = document) {
		var counters = root.querySelectorAll("[data-countup-to]");
		if (!counters.length || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
		function animate(el) {
			if (el.dataset.counted === "true") return;
			el.dataset.counted = "true";
			var target = parseFloat(el.getAttribute("data-countup-to")) || 0;
			var duration = parseFloat(el.getAttribute("data-countup-duration") || "1.2") * 1000;
			var startTime = performance.now();
			var valEl = el.querySelector(".countup-val") || el;
			function step(now) {
				var elapsed = now - startTime;
				var progress = Math.min(elapsed / duration, 1);
				var ease = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
				valEl.textContent = Math.round(target * ease);
				if (progress < 1) {
					requestAnimationFrame(step);
				} else {
					valEl.textContent = target;
				}
			}
			requestAnimationFrame(step);
		}
		if ("IntersectionObserver" in window) {
			var observer = new IntersectionObserver(function(entries, obs) {
				entries.forEach(function(entry) {
					if (entry.isIntersecting) {
						animate(entry.target);
						obs.unobserve(entry.target);
					}
				});
			}, { threshold: 0.15 });
			counters.forEach(function(el) { observer.observe(el); });
		} else {
			counters.forEach(animate);
		}
	}

